class Author extends require("lib/static-shim").default(
  require("lib/utils/model").default
) {
  static initClass() {
    this.prototype.defaults = { order: 0 }

    this.prototype.gqlSync = {
      typename: "Author",
      keyMap: {
        display_name: {
          field: "display_name",
          resolver: (value, attributes) => {
            const firstName = attributes.first_name?.trim()
            const lastName = attributes.last_name?.trim()
            const lastInitial = lastName?.[0]?.toUpperCase()

            if (firstName && lastInitial) {
              return `${firstName} ${lastInitial}.`
            }

            return firstName || lastName || ""
          }
        },
        full_name: {
          field: "full_name",
          resolver: (value, attributes) => {
            return [attributes.first_name?.trim(), attributes.last_name?.trim()]
              .filter(Boolean)
              .join(" ")
          }
        }
      }
    }
  }

  url() {
    let url = this.urlRoot(`/api/private/library/author/`)
    if (this.id) {
      url += `${this.id}/`
    }
    return url
  }
}
Author.initClass()
export default Author
